import { apiRequest } from './httpClient';

// Agenda operativa única. Las mutaciones pasan por backend para que Firestore
// y Google Calendar se actualicen como una sola operación auditable.
export const SCHEDULE_COLLECTION = 'companyScheduleEvents';

export const createScheduleEvent = async (payload) => {
  return apiRequest('saveCompanyScheduleEvent', {
    method: 'POST',
    body: { event: payload },
    requireAuth: true,
  });
};

export const updateScheduleEvent = async (id, payload) => {
  return apiRequest('saveCompanyScheduleEvent', {
    method: 'POST',
    body: { event: { ...payload, id } },
    requireAuth: true,
  });
};

// Una cita operativa no se elimina físicamente: se cancela para conservar el
// historial y para que Google Calendar notifique a responsables y cliente.
export const deleteScheduleEvent = async (id) => {
  return apiRequest('cancelCompanyScheduleEvent', {
    method: 'POST',
    body: { eventId: id },
    requireAuth: true,
  });
};

export const getScheduleAvailability = ({ startAt, endAt, assigneeIds }) => apiRequest('getScheduleAvailability', {
  method: 'POST',
  body: { startAt, endAt, assigneeIds },
  requireAuth: true,
});
